//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/TaggedObjectCollection.js";
import "../Tooling/Tooling.ToolingManager.js";
let d=[[],[[["feature_set"],"CreateDieDesDrawPunchBuilder",{R_:{builder:"Tooling.DieDesDrawPunchBuilder"}},1,0],[["feature_set"],"CreateDieDesDrawDieBuilder",{R_:{builder:"Tooling.DieDesDrawDieBuilder"}},1,0],[["die_eng_form_task"],"CreateDieEngFormTaskBuilder",{R_:{builder:"Tooling.DieEngFormTaskBuilder"}},1,0],[[],"CreateDieDesPierceInsertBuilder",{R_:{builder:"Tooling.DieDesPierceInsertBuilder"}},0,0],[["die_eng_trim_angle_check"],"CreateDieEngTrimAngleCheckBuilder",{R_:{builder:"Tooling.DieEngTrimAngleCheckBuilder"}},1,0],[["frec"],"CreateDieDesignLowerBinderBuilder",{R_:{builder:"Tooling.DieDesignLowerBinderBuilder"}},1,0],[["frec"],"CreateDieDesignTrimPostBuilder",{R_:{builder:"Tooling.DieDesignTrimPostBuilder"}},1,0],[["die_eng_stamping_carryover"],"CreateDieEngStampingCarryoverBuilder",{R_:{builder:"Tooling.DieEngStampingCarryoverBuilder"}},1,0],[["frec"],"CreateDieEngStampingOutputBuilder",{R_:{builder:"Tooling.DieEngStampingOutputBuilder"}},1,0],[["frec"],"CreateDieEngTrimTaskBuilder",{R_:{builder:"Tooling.DieEngTrimTaskBuilder"}},1,0],[["frec"],"CreateDieEngProcessUpdateManagerBuilder",{R_:{builder:"Tooling.DieEngProcessUpdateManagerBuilder"}},1,0],[[],"CreateSetPressModelBuilder",{R_:{builder:"Tooling.SetPressModelBuilder"}},0,0],[[],"CreateSpindleSliderBuilder",{R_:{builder:"Tooling.SpindleSliderBuilder"}},0,0],[["frec"],"CreateDieEngDieTipBuilder",{R_:{builder:"Tooling.DieEngDieTipBuilder"}},1,0],[["frec"],"CreateDieEngLineUpBuilder",{R_:{builder:"Tooling.DieEngLineupBuilder"}},1,0],[["feature_set"],"CreateDieEngDefineProductOrientationBuilder",{R_:{builder:"Tooling.DieEngDefineProductOrientationBuilder"}},1,0],[["die_eng_flange_task"],"CreateDieEngFlangeTaskBuilder",{R_:{builder:"Tooling.DieEngFlangeTaskBuilder"}},1,0],[[],"CreateDieDesPlaneListBuilder",{R_:{builder:"Tooling.DieDesPlaneListBuilder"}},0,0],[["frec"],"CreateDieDesTrmstlFeatBuilder",{R_:{builder:"Tooling.DieDesTrmStlFeatBuilder"}},1,0],[["trimLineFeat"],"CreateDieEngTrimLineBuilder",{R_:{builder:"Tooling.DieEngTrimLineBuilder"}},1,0]],[]];
SPLM.Tooling.AutoDieCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Tooling.AutoDieCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;